import ACTS from '../constants'
import { store } from '../store'

const defaultStatus = {
    info: []
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        case ACTS.GET_MEMBER_INFO:
            return {
                ...state,
                info : action.payload.item.info
            }
        case ACTS.INSERT_CONSULTING:
            if(action.payload.status === "success"){
                alert(action.payload.msg);
                window.location.href = '/login';
            }else{
                alert('처리도중 오류가 발생했습니다.')
            }
            return {
                ...state
            }
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/consulting.js